import React from 'react';
import { GoogleFilesPanel } from './GoogleFilesPanel';
import { ClipboardList } from 'lucide-react';
export function GoogleFormsPanel() {
  return <GoogleFilesPanel title="Google Forms" description="Formularios, encuestas y recolección de datos." mimeType="application/vnd.google-apps.form" icon={<ClipboardList size={24} data-id="element-4957" />} colorClass="text-purple-400" bgClass="bg-purple-500/10" borderClass="border-purple-500/20" glowClass="bg-purple-500/10" data-id="element-4956" />;
}